import React from "react";
import { createRoot } from "react-dom/client";
import "core-js/stable";
import "regenerator-runtime/runtime";
import "smartbanner.js";
import "../../../vendor/assets/stylesheets/intlTelInput.css";
import "../assets/stylesheets/application.scss";
import "./settings.js.coffee";
import "./ajax_error.js";

import ScrollTopButton from "../components/ScrollTopButton/index.js";
import { xlsxExport } from "../utils/xlsxExport";

var componentRequireContext = require.context("pages", true);

let sharedContext = require.context("shared", true);
var ReactRailsUJS = require("react_ujs");

ReactRailsUJS.useContexts([componentRequireContext, sharedContext]);

/**
 *
 * @param chartName String
 * @param linkNames String
 * @param fromContext Boolean|Null
 */
let animationNonReactChart = function (chartName, linkNames, fromContext) {
  const loader = `<div class="md-cs-loader bg"><div class="md-cs-loader-inner"><div class="stairs-up-loader"><div class="stairs-up-loader__bar"></div><div class="stairs-up-loader__bar"></div><div class="stairs-up-loader__bar"></div><div class="stairs-up-loader__bar"></div><div class="stairs-up-loader__bar"></div><div class="stairs-up-loader__ball"></div></div><p>Updating data...</p></div></div>`;
  $(document).on("click", `${linkNames}`, function () {
    let chartNameSelector = chartName;
    if (fromContext) {
      chartNameSelector = $(this).context.dataset.chartName;
    }
    $("#" + chartNameSelector)
      .find(".md-cs-loader")
      .remove();
    $("#" + chartNameSelector).append(loader);
  });
};

window.xlsxROR = function (data, headers) {
  xlsxExport({ data, headers, fileName: "raw_data" });
};

window.addEventListener("DOMContentLoaded", () => {
  createRoot(document.querySelector("#scrollTopButton")).render(React.createElement(ScrollTopButton));
});

window.app = {
  helpers: {
    animationNonReactChart
  }
};
